import { makeStyles } from "@material-ui/styles";

export const PointerCircle = () => {
  const classes = useStyles();
  return <div className={classes.circle} />
}

const useStyles = makeStyles(() => ({

  circle: {
    width: 12,
    height: 12,
    borderRadius: 6,
    border: "2px solid #fff",
    transform: "translate(-6px, -6px)",
  }
}))